<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "名字",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderFirstNameCN`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderFirstNameCN`
						},
						createOptions: {
							type: `sourceOfFundsProviderFirstNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "姓名",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderLastNameCN`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderLastNameCN`
						},
						createOptions: {
							type: `sourceOfFundsProviderLastNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "与被保险人关系",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sourceOfFundsProviderRelationshipCN`,
					props: {
						suggest: {
							typeIncludes: `sourceOfFundsProviderRelationshipCN`
						},
						createOptions: {
							type: `sourceOfFundsProviderRelationshipCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
